import React, { } from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function IssueSlipTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "po no.", field: "productionordernumber" },
    { label: "Part Number", field: "partno" },
    { label: "job number", field: "jobnumber" },
    { label: "stock type", field: "stocktype" },
    { label: "Issue Slip Date", field: "issuedate" },
    { label: "Action", field: "action" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"MATERIAL ISSUE SLIP LIST"}
        apiField={"materialissueslip"}
        addButton={"+ ADD"}
        createRoute={"/IssueSlipCreate"}
        updateRoute={"/IssueSlipView"}
        viewRoute={"/IssueSlipView"}
      />
    </div>
  );
}

export default IssueSlipTable;
